<template>
  <div class="p-4 grid grid-cols-1 gap-y-4 gap-x-2 glass-frosted rounded-8xl sm:grid-cols-2">
    <div
      v-for="setting in settings"
      :key="setting.id"
      class="p-3 flex items-center gap-3 bg-key rounded-4xl"
      :class="setting.compact ? '' : 'sm:col-span-2'"
    >
      <div class="min-w-0 flex-1">
        <h3 class="text-l-medium text-black-white">{{ setting.title }}</h3>
        <p class="mt-0.5 text-s-medium text-text-glass-default">{{ setting.description }}</p>
      </div>
      <Switch
        size="lg"
        :aria-label="setting.title"
        :model-value="setting.value"
        @update:model-value="updateSetting(setting.id, $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Switch } from '@rapoo/element'
  import type { KeyboardPerformanceToggle, KeyboardPerformanceToggleSetting } from '../types'

  defineProps<{
    settings: KeyboardPerformanceToggleSetting[]
  }>()

  const emit = defineEmits<{
    'update:setting': [
      value: {
        id: KeyboardPerformanceToggle
        value: boolean
      },
    ]
  }>()

  function updateSetting(id: KeyboardPerformanceToggle, value: boolean) {
    emit('update:setting', { id, value })
  }
</script>
